"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
exports.__esModule = true;
var styled_components_1 = require("styled-components");
var lib_1 = require("kaizen-ui-colors/lib");
var ChartDescription = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 1.0769rem;\n  color: ", ";\n"], ["\n  font-size: 1.0769rem;\n  color: ", ";\n"])), lib_1.colors.slate_light__707889);
exports["default"] = ChartDescription;
var templateObject_1;
